/**
 * The customer-facing tax line and total for a booking. Calls the same
 * computeBookingTax the checkout routes charge with, so the displayed total and
 * the charged total cannot differ. Pure.
 */
import { computeBookingTax, type BookingTax } from '@sifly/shared-utils'

export type BookingTaxDisplay = {
  tax: BookingTax
  totalCents: number
  taxLine: { label: string; amountCents: number } | null
}

export function bookingTaxDisplay(
  subtotalCents: number,
  taxRatePct: number | null,
  taxTreatment: string | null | undefined,
): BookingTaxDisplay {
  const tax = computeBookingTax({ ratePct: taxRatePct, taxTreatment, subtotalCents })
  return {
    tax,
    totalCents: subtotalCents + tax.taxCents,
    taxLine: tax.taxCents > 0 ? { label: `Sales tax (${tax.taxRatePct}%)`, amountCents: tax.taxCents } : null,
  }
}
